export default () => {
  const script = document.createElement('script')
  script.src = 'https://apps.8thwall.com/xrweb?appKey=' + process.env.eighthWallKey
  script.defer = true
  document.head.appendChild(script)
}
